import {
  FETCH_EXERCISE_REQUEST,
  RECEIVE_EXERCISE,
  RECEIVE_EXERCISE_ERROR,
} from 'redux/constants/ActionTypes'

import { createFileAction } from './FileActions'

export const fetchExercise = (currentLocale, slug) => {
  return createFileAction({
    slug,
    types: [FETCH_EXERCISE_REQUEST, RECEIVE_EXERCISE, RECEIVE_EXERCISE_ERROR],
    currentLocale,
  })
}
